import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

interface ProtectedRouteProps {
  children: React.ReactNode
  isAuthenticated: boolean
  redirectTo?: string
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  isAuthenticated,
  redirectTo = '/login',
}) => {
  const location = useLocation()

  // Check localStorage as fallback in case state hasn't updated yet
  // This fixes the race condition where login updates state but App hasn't re-rendered
  const hasToken = typeof window !== 'undefined' && localStorage.getItem('authToken')
  const isActuallyAuthenticated = isAuthenticated || !!hasToken

  if (!isActuallyAuthenticated) {
    // Redirect to login page, saving the attempted location
    return <Navigate to={redirectTo} state={{ from: location }} replace />
  }

  return <>{children}</>
}

